import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin-bottom: 4px;

  .grouped-status-menu-return-button {
    height: 100%;
    position: absolute;
    left: 4px;

    .anticon {
      opacity: 0.4;
    }
  }
`;
